(function () {
  'use strict';

  if (window.__ecCartSummaryLoaded) return;
  window.__ecCartSummaryLoaded = true;

  function makeFormatter(moneyFormat) {
    var fallback = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    if (!moneyFormat || moneyFormat.indexOf('{{') === -1) {
      return function (cents) { return fallback.format((cents || 0) / 100); };
    }
    return function (cents) {
      var value = (cents || 0) / 100;
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
        switch (key) {
          case 'amount':
            return value.toFixed(2);
          case 'amount_with_comma_separator':
            return value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          case 'amount_no_decimals':
            return String(Math.round(value));
          case 'amount_no_decimals_with_comma_separator':
            return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          default:
            return value.toFixed(2);
        }
      });
    };
  }

  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = '';
    try {
      url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    } catch (e) { /* noop */ }
    var promise = origFetch.apply(this, args);
    if (CART_URL.test(url)) {
      promise.then(function () {
        document.dispatchEvent(new CustomEvent('ec:cart:changed'));
      }).catch(function () {});
    }
    return promise;
  };

  /* ------------------------------ widget ------------------------------ */
  function ECCartSummary(root) {
    this.root = root;
    this.threshold = parseInt(root.dataset.threshold, 10) || 3500;
    this.formatMoney = makeFormatter(root.dataset.moneyFormat);
    this.busy = false;
    this.compareCache = {};

    this.el = {
      shipbar: root.querySelector('[data-ec-shipbar]'),
      shipText: root.querySelector('[data-ec-shipbar-text]'),
      shipFill: root.querySelector('[data-ec-shipbar-fill]'),
      shipDot: root.querySelector('[data-ec-shipbar-dot]'),
      toggle: root.querySelector('[data-ec-toggle]'),
      body: root.querySelector('[data-ec-body]'),
      count: root.querySelector('[data-ec-count]'),
      chips: root.querySelector('[data-ec-chips]'),
      input: root.querySelector('[data-ec-input]'),
      apply: root.querySelector('[data-ec-apply]'),
      applyLabel: root.querySelector('[data-ec-apply-label]'),
      msg: root.querySelector('[data-ec-msg]'),
      subtotal: root.querySelector('[data-ec-subtotal]'),
      savingsRow: root.querySelector('[data-ec-row-savings]'),
      savings: root.querySelector('[data-ec-savings]'),
      shipping: root.querySelector('[data-ec-shipping]'),
      total: root.querySelector('[data-ec-total]')
    };

    this.bind();
    this.refresh();
  }

  ECCartSummary.prototype.bind = function () {
    var self = this;

    this.el.toggle.addEventListener('click', function () {
      var expanded = self.el.toggle.getAttribute('aria-expanded') === 'true';
      self.el.toggle.setAttribute('aria-expanded', String(!expanded));
      self.el.body.hidden = expanded;
      if (!expanded) self.el.input.focus();
    });

    this.el.apply.addEventListener('click', function () {
      self.applyCode();
    });

    this.el.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        self.applyCode();
      }
    });

    this.el.chips.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ec-remove]');
      if (btn) self.removeCode(btn.dataset.code);
    });

    var onCartChanged = function () {
      if (!document.documentElement.contains(self.root)) return;
      if (!self.busy) self.refresh();
    };

    ['ec:cart:changed', 'cart:updated', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, onCartChanged);
    });
    document.documentElement.addEventListener('wetheme-cart-update', onCartChanged);
  };

  ECCartSummary.prototype.getCart = function () {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  };

  ECCartSummary.prototype.updateDiscounts = function (codes) {
    return origFetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  };

  ECCartSummary.prototype.refresh = function () {
    var self = this;
    this.getCart().then(function (cart) { self.render(cart); }).catch(function () {});
  };

  ECCartSummary.prototype.applyCode = function () {
    var self = this;
    var code = (this.el.input.value || '').trim();
    if (!code || this.busy) return;

    this.setBusy(true);
    this.showMsg('');

    this.getCart()
      .then(function (cart) {
        var existing = (cart.discount_codes || []).map(function (d) { return d.code; });
        var codes = existing.filter(function (c) {
          return c.toLowerCase() !== code.toLowerCase();
        });
        codes.push(code);

        return self.updateDiscounts(codes).then(function (updated) {
          var match = (updated.discount_codes || []).find(function (d) {
            return d.code.toLowerCase() === code.toLowerCase();
          });

          if (!match || match.applicable === false) {
            // wycofaj nieprawidłowy kod
            return self.updateDiscounts(existing).then(function (rolledBack) {
              self.render(rolledBack);
              self.showMsg('Dieser Code ist leider nicht gültig.', 'error');
            });
          }

          self.el.input.value = '';
          self.render(updated);
          self.showMsg('Code "' + match.code + '" wurde angewendet.', 'success');
          self.notifyTheme();
        });
      })
      .catch(function () {
        self.showMsg('Etwas ist schiefgelaufen. Bitte versuche es erneut.', 'error');
      })
      .finally(function () {
        self.setBusy(false);
      });
  };

  ECCartSummary.prototype.removeCode = function (code) {
    var self = this;
    if (this.busy) return;
    this.setBusy(true);
    this.showMsg('');

    this.getCart()
      .then(function (cart) {
        var remaining = (cart.discount_codes || [])
          .map(function (d) { return d.code; })
          .filter(function (c) { return c.toLowerCase() !== String(code).toLowerCase(); });

        return self.updateDiscounts(remaining).then(function (updated) {
          self.render(updated);
          self.notifyTheme();
        });
      })
      .catch(function () {})
      .finally(function () { self.setBusy(false); });
  };

  ECCartSummary.prototype.notifyTheme = function () {
    document.documentElement.dispatchEvent(new CustomEvent('wetheme-cart-update'));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  };

  ECCartSummary.prototype.render = function (cart) {
    var self = this;
    this.paint(cart);
    this.ensureCompareData(cart).then(function (fetchedNew) {
      if (fetchedNew) self.paint(cart);
    });
  };

  ECCartSummary.prototype.ensureCompareData = function (cart) {
    var self = this;
    var handles = {};
    (cart.items || []).forEach(function (item) {
      if (!(item.variant_id in self.compareCache) && item.handle) {
        handles[item.handle] = true;
      }
    });
    var toFetch = Object.keys(handles);
    if (!toFetch.length) return Promise.resolve(false);

    return Promise.all(toFetch.map(function (handle) {
      return origFetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          (product.variants || []).forEach(function (v) {
            self.compareCache[v.id] = v.compare_at_price || 0;
          });
        })
        .catch(function () { /* produkt niedostępny — pomijamy */ });
    })).then(function () {
      (cart.items || []).forEach(function (item) {
        if (!(item.variant_id in self.compareCache)) {
          self.compareCache[item.variant_id] = 0;
        }
      });
      return true;
    });
  };

  ECCartSummary.prototype.compareSavings = function (cart) {
    var self = this;
    var sum = 0;
    (cart.items || []).forEach(function (item) {
      var compareAt = self.compareCache[item.variant_id] || 0;
      if (compareAt > item.original_price) {
        sum += (compareAt - item.original_price) * item.quantity;
      }
    });
    return sum;
  };

   ECCartSummary.prototype.paint = function (cart) {
    var el = this.el;
    var total = cart.total_price || 0;
    var original = cart.original_total_price || total;
    var compareExtra = this.compareSavings(cart);
    // rabaty (kody + automatyczne) + oszczędność z przekreślonych cen
    var savings = Math.max(0, original - total) + compareExtra;
    var subtotal = original + compareExtra;

    // pasek wysyłki (w drawerze renderuje go Vue — elementy mogą nie istnieć)
    var pct = Math.min(100, Math.round((total / this.threshold) * 100));
    if (el.shipFill) el.shipFill.style.width = pct + '%';
    if (el.shipDot) el.shipDot.style.left = pct + '%';
    if (el.shipText) {
      if (total >= this.threshold) {
        el.shipText.innerHTML = '🎉 Du erhältst <strong>kostenlosen Versand</strong>!';
      } else {
        el.shipText.innerHTML =
          'Noch <strong>' + this.formatMoney(this.threshold - total) +
          '</strong> bis zum <strong>kostenlosen Versand</strong>';
      }
    }

    // chipy z kodami
    var codes = (cart.discount_codes || []).filter(function (d) {
      return d.applicable !== false;
    });
    if (el.chips) {
      el.chips.innerHTML = codes.map(function (d) {
        var safe = String(d.code).replace(/[<>&"]/g, '');
        return '<span class="ec-chip">' + safe +
          '<button type="button" class="ec-chip__remove" data-ec-remove data-code="' + safe +
          '" aria-label="Code ' + safe + ' entfernen">&times;</button></span>';
      }).join('');
    }
    if (el.count) {
      el.count.hidden = codes.length === 0;
      el.count.textContent = codes.length;
    }

    // sumy (w drawerze renderuje je Vue)
    if (el.subtotal) el.subtotal.textContent = this.formatMoney(subtotal);
    if (el.savingsRow) el.savingsRow.hidden = savings === 0;
    if (el.savings) el.savings.textContent = '\u2212' + this.formatMoney(savings);
    if (el.shipping) {
      el.shipping.innerHTML = total >= this.threshold
        ? '<strong>Gratis</strong>'
        : 'Gratis ab ' + this.formatMoney(this.threshold);
    }
    if (el.total) el.total.textContent = this.formatMoney(total);
  };

  /* ------------------------------ utils ------------------------------- */
  ECCartSummary.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.el.apply.disabled = busy;
    this.el.applyLabel.textContent = busy ? '…' : 'Anwenden';
  };

  ECCartSummary.prototype.showMsg = function (text, type) {
    var el = this.el.msg;
    el.hidden = !text;
    el.textContent = text || '';
    el.className = 'ec-codefield__msg' + (type ? ' ec-codefield__msg--' + type : '');
  };

  /* ------------------------------- init ------------------------------- */
  function init() {
    document.querySelectorAll('[data-ec-cart-summary]').forEach(function (root) {
      if (!root.__ecInit) {
        root.__ecInit = true;
        new ECCartSummary(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(init).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();